import styled from 'styled-components';
import Switch from '@mui/material/Switch';
import Icons from '../Icons';
import { H3 } from '../../style/Typography';

export const StyledToggle = styled.div.attrs({ className: 'dsc-toggle' })`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
`;

export const StyledSwitch = styled(Switch)`
  && {
    width: 32px;
    height: 16px;
    padding: 0;
    display: flex;
    .MuiSwitch-switchBase {
      padding: 2px;
      color: var(--toggle-off-thumb-color);
    }
    .Mui-checked {
      transform: translateX(16px);
    }

    & .MuiSwitch-thumb {
      color: var(--toggle-off-thumb-color);
      /* Was rgb(var(--slider-thumb-color) / 20%) - that var holds a hex, so the whole
         declaration was invalid and no shadow ever rendered. */
      box-shadow: var(--toggle-thumb-shadow, none);
      width: 12px;
      height: 12px;
      border-radius: 6px;
      transition-duration: 0.5s;
    }
    .Mui-checked .MuiSwitch-thumb {
      opacity: 1;
      background-color: var(--toggle-on-thumb-color);
    }
    .Mui-disabled .MuiSwitch-thumb {
      opacity: var(--toggle-disabled-thumb-opacity, var(--disabled-opacity));
    }
    &:hover {
      .MuiSwitch-switchBase:not(.Mui-disabled) .MuiSwitch-thumb {
        background-color: var(--toggle-hover-thumb-color);
      }
      .Mui-checked:not(.Mui-disabled) .MuiSwitch-thumb {
        background-color: var(--toggle-on-thumb-color);
      }
    }

    & .MuiSwitch-track {
      border-radius: var(--toggle-track-radius, 8px);
      opacity: 1;
      background-color: var(--toggle-off-track-color);
      box-sizing: border-box;
    }
    .Mui-checked + .MuiSwitch-track {
      opacity: 1;
      background-color: var(--toggle-on-track-color);
    }
    /* Point moves the TRACK on hover/active, not the thumb. Fallbacks are the resting colours,
       so a theme that defines nothing here keeps its current behaviour. */
    &:hover .MuiSwitch-switchBase:not(.Mui-disabled, .Mui-checked) + .MuiSwitch-track {
      background-color: var(--toggle-off-track-hover-color, var(--toggle-off-track-color));
    }
    &:active .MuiSwitch-switchBase:not(.Mui-disabled, .Mui-checked) + .MuiSwitch-track {
      background-color: var(--toggle-off-track-active-color, var(--toggle-off-track-color));
    }
    &:hover .Mui-checked:not(.Mui-disabled) + .MuiSwitch-track {
      background-color: var(--toggle-on-track-hover-color, var(--toggle-on-track-color));
    }
    &:active .Mui-checked:not(.Mui-disabled) + .MuiSwitch-track {
      background-color: var(--toggle-on-track-active-color, var(--toggle-on-track-color));
    }
    .Mui-disabled + .MuiSwitch-track {
      cursor: not-allowed;
      opacity: var(--disabled-opacity, var(--toggle-disabled-track-opacity));
    }
  }
`;

export const StyledLabel = styled(H3)`
  color: var(--label-color);
`;

export const LoadingIcon = styled(Icons.InProgress)`
  position: absolute;
  top: -8px;
  ${({ $leading }) => ($leading ? 'left: -8px;' : 'right: -8px;')}
`;
